<script>
    import {getStyleValue, imageUrl} from "../../Common/tools"
    import TextEditor from "../../Common/TextEditor.svelte";
    import Button from "./Button.svelte";
    import {External} from "../../external";

    export let data, meta, globalStyle, onChange;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }

    $: if (!data.buttonStyle) data.buttonStyle = {};
</script>
<tr>
    <td>
        <table>
            <tbody>
            <tr>
              {#if !data.switched}
                  <th class="column mobile-padding-top mobile-padding-bottom"
                      width="{getStyleValue(globalStyle.width, 600)*.5}">
                      <table width="100%" cellspacing="0" cellpadding="0">
                          <tbody>
                          <tr>
                              <th style="padding-left: 40px; padding-right: 40px; font-size: 13px; font-weight: 400; text-align: left;">
                                  <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
                                  <div class="spacer"
                                       style="font-size: 40px; line-height: 40px; mso-line-height-rule: exactly;">&nbsp;
                                  </div>
                                  <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                              </th>
                          </tr>
                          </tbody>
                      </table>
                  </th>
                  <th class="column mobile-padding-bottom"
                      style="background-repeat: no-repeat; background-position: center; background-size: cover;"
                      width="{getStyleValue(globalStyle.width, 600)*.5}" 
                      background="{imageUrl(data, External.resources + '/images/marketing/placeholders/350x490.png')}">
                      <div class="spacer spacer-big"
                           style="height: 490px; mso-line-height-rule: exactly;">
                          &nbsp;
                      </div>
                  </th>
              {:else}
                  <th class="column mobile-padding-bottom"
                      style="background-repeat: no-repeat; background-position: center; background-size: cover;"
                      width="{getStyleValue(globalStyle.width, 600)*.5}" 
                      background="{imageUrl(data, External.resources + '/images/marketing/placeholders/350x490.png')}">
                      <div class="spacer"
                           style="height: 490px; mso-line-height-rule: exactly;">
                          &nbsp;
                      </div>
                  </th>
                  <th class="column mobile-padding-top mobile-padding-bottom"
                      width="{getStyleValue(globalStyle.width, 600)*.5}">
                      <table width="100%" cellspacing="0" cellpadding="0">
                          <tbody>
                          <tr>
                              <th style="padding-left: 40px; padding-right: 40px; font-size: 13px; font-weight: 400; text-align: left;">
                                  <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
                                  <div class="spacer spacer-big"
                                       style="font-size: 40px; line-height: 40px; mso-line-height-rule: exactly;">&nbsp;
                                  </div>
                                  <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
                              </th>
                          </tr>
                          </tbody>
                      </table>
                  </th>
              {/if}
            </tr>
            </tbody>
        </table>
    </td>
</tr>